"use client";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export interface AboutSectionProps {
  aboutUsImageUrl?: string;
  aboutUsHeader?: string;
  aboutUsText?: string;
  merchantName: string;
}

export const AboutSection = ({
  aboutUsImageUrl = "",
  aboutUsHeader = "",
  aboutUsText = "",
  merchantName,
}: AboutSectionProps) => {
  const t = useTranslations("AboutSection");
  return (
    <div
      data-testid={applyDataTestId(pom.about.aboutSection)}
      className={[
        "w-full",
        "flex",
        "flex-col",
        "sm:flex-row",
        "px-4",
        "sm:px-[60px]",
        "py-16",
        "gap-14",
        "items-start",
        "justify-center",
      ].join(" ")}
    >
      <div className="basis-1/2 flex justify-center">
        <Image
          src={aboutUsImageUrl}
          alt={
            merchantName && aboutUsHeader
              ? `${merchantName} - ${aboutUsHeader}`
              : t("imageAlt")
          }
          priority
          width={500}
          height={500}
          className="w-full h-auto rounded-lg"
        />
      </div>
      <section className="basis-1/2 flex flex-col gap-6">
        <h2 className="font-medium text-[40px]">{aboutUsHeader}</h2>
        <p className="text-[15px] max-w-[560px] text-[#637381]">
          {aboutUsText}
        </p>
      </section>
    </div>
  );
};
